export const API_PATH = process.env.REACT_APP_API_URL
export const DOCUMENTOS_BUCKET = process.env.REACT_APP_DOCUMENTOS_BUCKET